import { eAtlas, Game } from "../../../Game";
import { AtlasAnimClip, AtlasAnimClipData } from "../../../Utils/Atlas/AtlasAnimClip";
import { ScaleManager } from "../../../Utils/ScaleManager";
import { TIMER } from "../../Gameplay";

/**
 * FlipBook efekt za textem zpravy
 */
export class AnimMessageBgFx {
    private _entity: pc.Entity;
    private _animClip: AtlasAnimClip;
    private _posY: number;

    get isActive(): boolean { return this._entity.enabled; }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    constructor(screen: pc.Entity) {
        // Entita
        this._entity = new pc.Entity();
        this._entity.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            anchor: new pc.Vec4(0.5, 1, 0.5, 1),
            pivot: new pc.Vec2(0.5, 0.5),
        });
        this._entity.enabled = false;
        screen.addChild(this._entity);

        // Animace
        this._animClip = new AtlasAnimClip(TIMER);
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    reset(): void {
        if (this._entity.enabled) {
            this._entity.enabled = false;
            this._animClip.reset();

            Game.app.off(ScaleManager.EVENT_RESIZE, this.updateYPos, this);
        }
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    play(posY: number, width: number, anim: AtlasAnimClipData): void {
        this._animClip.play(anim);

        this._posY = posY;
        this.updateYPos();

        let element = this._entity.element;

        element.width = Math.round(Game.scale.width * width);
        element.height = Math.round(this._animClip.framePixSize.y * (element.width / this._animClip.framePixSize.x));
        element.rect = this._animClip.curFrameRect;
        element.texture = anim.atlas.texture;
        this._entity.enabled = true;

        // Zachytavat zmenu rozliseni
        Game.app.on(ScaleManager.EVENT_RESIZE, this.updateYPos, this);
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    update(): boolean {
        if (!this._entity.enabled)
            return false;

        if (this._animClip.update()) {
            if (this._animClip.isPlaying) {
                this._entity.element.rect = this._animClip.curFrameRect;
            }
            else {
                this.reset();
                return false;
            }
        }

        return true;
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    private updateYPos(): void {
        this._entity.setLocalPosition(0, -Game.scale.minHeight * this._posY, 0);
    }
}